import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./ComponentsStyles/Navbar02.css";
import ServiceList from "../DB/AllServicesList";
import clogo from "../Assets/logo.png";
import { IoClose } from "react-icons/io5";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { getUserData } from "../utils/auth";
import smallLogo from "../Assets/rbdLogo.png";
import CountrySelector from "./CountrySelector";

const SecondaryNavbar = ({ inDashboard }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [showPrimary, setShowPrimary] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isTabletView, setIsTabletView] = useState(
    window.innerWidth >= 769 && window.innerWidth <= 1130
  );

  const [isMidScreen, setIsMidScreen] = useState(
    window.innerWidth >= 1130 && window.innerWidth <= 1430
  );

  const user = getUserData();
  const userType = localStorage.getItem("userType");

  const serviceList = [
    { name: "Pathology", path: "/pathology" },
    { name: "Radiology", path: "/imagine" },
    { name: "Holistic Care", path: "/holistic-Care" },
    { name: "Health Packages", path: "/OurPackagesPage" },
    // { name: "Adv Service Booking", path: "/advServiceBookng"},
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMidScreen(window.innerWidth >= 1130 && window.innerWidth <= 1430);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const location = useLocation();

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const closeMenu = () => {
    setMenuOpen(false);
    setIsServicesOpen(false);
    setOpenDropdown(null);
  };

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  useEffect(() => {
    let lastScrollY = window.scrollY;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY <= 0) {
        setShowPrimary(true);
        setIsSticky(false);
      } else if (currentScrollY > lastScrollY) {
        setShowPrimary(false);
        setIsSticky(true);
      } else {
        setShowPrimary(true);
        setIsSticky(true);
      }
      lastScrollY = currentScrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsTabletView(window.innerWidth >= 769 && window.innerWidth <= 1130);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const navbar = document.querySelector(".secondary-navbar");
      if (navbar && !navbar.contains(event.target)) {
        closeMenu();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleServicesToggle = () => {
    setIsServicesOpen((prev) => !prev);
  };

  const handleDropdownToggle = (menuName) => {
    setOpenDropdown((prev) => (prev === menuName ? null : menuName));
  };

  const ServiceItem = ({ service }) => {
    const fullPath = `/service${service.path}`;

    return (
      <li className="dropdown-item">
        <Link
          to={fullPath}
          className={location.pathname === fullPath ? "active" : ""}
          onClick={closeMenu}
        >
          {service.name}
        </Link>
      </li>
    );
  };

  const renderServices = (services) => (
    <ul className="dropdown-menu">
      {serviceList.map((service, index) => (
        <ServiceItem key={index} service={service} />
      ))}
    </ul>
  );

  const corporateWellnessData = [
    { path: "/corporate-wellness", label: "Corporate Wellness" },
    { label: "B2B", path: "/service/B2B" },
  ];

  const coreTabs = [
    { path: "/", label: "Home" },
    // { path: "/collection", label: "Home Collection" },
    { path: "/home-collection", label: "Home Collection" },
    { path: "/view-reports", label: "View Report" },
    // { path: "/test-packages", label: "Tests" },
    // { path: "/OurPackagesPage", label: "Health Package" },
    { label: "Services", dropdown: true },
    // { label: "Service copy", dropdown: true },
    { path: "/corporate-wellness", label: "Corporate Wellness" },
    // {
    //   label: "Corporate-wellness",
    //   dropdown: true,
    //   children: corporateWellnessData,
    // },
  ];

  const aboutDropdownItems = [
    { path: "/about-us", label: "Overview" },
    { path: "/all-members", label: "Meet Our Experts" },
    { path: "/contact-us", label: "Location" },
    { path: "/career", label: "Career" },
  ];

  // if (isMidScreen) {
  //   aboutDropdownItems.push({ path: "/corporate-wellness", label: "Corporate Wellness" });
  // }

  const otherTabs = [
    { path: "/doctors-grid", label: "OPD" },
    { path: "/faqs", label: "FAQs" },
    {
      path: "https://rbdiagnostic.com/rbmembership/",
      label: "Membership",
      external: true,
    },
    {
      label: "About Us",
      dropdown: true,
      children: aboutDropdownItems,
    },
    // ...(!isMidScreen
    //   ? [{ path: "/corporate-wellness", label: "Corporate Wellness" }]
    //   : []),

    user
      ? {
          label: user.username,
          path: userType === "patient" ? "/dashboard" : "/corporate",
        }
      : { path: "/users/login", label: "Login" },
  ];

  const DropdownItem = ({ item, parentPath = "" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const fullPath = `${parentPath}${item.path || ""}`;
    const hasChildren = item.children && item.children.length > 0;

    return (
      <li className="dropdown-item">
        {hasChildren ? (
          <>
            <span
              onClick={() => setIsOpen((prev) => !prev)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                cursor: "pointer",
                marginLeft: "6px",
              }}
            >
              {item.label}{" "}
              {isOpen ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
            </span>

            {isOpen && (
              <ul className="sub-dropdown">
                {item.children.map((child, i) => (
                  <DropdownItem key={i} item={child} parentPath={fullPath} />
                ))}
              </ul>
            )}
          </>
        ) : (
          <Link
            to={fullPath}
            className={location.pathname === fullPath ? "active" : ""}
            onClick={closeMenu}
          >
            {item.label}
          </Link>
        )}
      </li>
    );
  };

  const renderDropdown = (items) => (
    <ul className="dropdown-menu">
      {items.map((item, i) => (
        <DropdownItem key={i} item={item} />
      ))}
    </ul>
  );
  return (
    <div
      className={`secondary-navbar ${
        isSticky
          ? showPrimary
            ? "sticky with-primary"
            : "sticky no-primary"
          : "below-primary"
      }`}
    >
      <div className="menu-toggle-wrapper">
        <div
          className="toggle-logo"
          style={{ visibility: inDashboard ? "hidden" : "" }}
        >
          <img src={clogo} alt="Company Logo" />
        </div>

          
 <div className="rightLeftSection">
          <img
              src="https://rbdiagnostic.com/assets/img/nabl-logo.png"
              alt="NABL Logo"
              className="nablLogo"
            />
                        <CountrySelector />
                      </div>







        <div
          className="menu-toggle"
          onClick={toggleMenu}
          role="button"
          tabIndex={0}
        >
          {menuOpen ? (
            <IoClose />
          ) : (
            <div className="bar-div">
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </div>
          )}
        </div>
      </div>

      <ul
        className={`nav-menu ${menuOpen ? "open" : ""} ${
          isSticky ? "scrolled" : ""
        }`}
      >
        <li className="brand-sm-logo-container">
          <Link to="/">
            <img src={smallLogo} alt="Small Logo" className="brand-sm-logo" />
          </Link>
        </li>
        {/* {coreTabs.map((tab, idx) => (
          <li key={idx} className={tab.dropdown ? "dropdown" : ""}>
            {!tab.dropdown ? (
              <Link
                to={tab.path}
                className={location.pathname === tab.path ? "active" : ""}
                onClick={closeMenu}
              >
                {tab.label}
              </Link>
            ) : (
              <>
                <span
                  onClick={handleServicesToggle}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    cursor: "pointer",
                  }}
                >
                  {tab.label}{" "}
                  {isServicesOpen ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                </span>
                {isServicesOpen && renderServices(ServiceList)}
              </>
            )}
          </li>
        ))} */}

        {coreTabs.map((tab, idx) => (
          <li key={idx} className={tab.dropdown ? "dropdown" : ""}>
            {/* Normal Tab (no dropdown) */}
            {!tab.dropdown ? (
              <Link
                to={tab.path}
                className={location.pathname === tab.path ? "active" : ""}
                onClick={closeMenu}
              >
                {tab.label}
              </Link>
            ) : (
              <>
                {/* When tab is Services */}
                {tab.label === "Services" ? (
                  <>
                    <span
                      onClick={() =>
                        setOpenDropdown((prev) =>
                          prev === "Services" ? null : "Services"
                        )
                      }
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        cursor: "pointer",
                      }}
                    >
                      {tab.label}{" "}
                      {openDropdown === "Services" ? (
                        <IoMdArrowDropup />
                      ) : (
                        <IoMdArrowDropdown />
                      )}
                    </span>

                    {openDropdown === "Services" && renderServices(ServiceList)}
                  </>
                ) : null}

                {/* When tab is Test Section */}
                {tab.label === "Corporate-wellness" ? (
                  <>
                    <span
                      onClick={() =>
                        setOpenDropdown((prev) =>
                          prev === "Corporate-wellness"
                            ? null
                            : "Corporate-wellness"
                        )
                      }
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        cursor: "pointer",
                      }}
                    >
                      {tab.label}{" "}
                      {openDropdown === "Corporate-wellness" ? (
                        <IoMdArrowDropup />
                      ) : (
                        <IoMdArrowDropdown />
                      )}
                    </span>

                    {openDropdown === "Corporate-wellness" &&
                      renderDropdown(tab.children)}
                  </>
                ) : null}
              </>
            )}
          </li>
        ))}

        {otherTabs.map((tab, idx) => (
          <li key={idx} className={tab.dropdown ? "dropdown" : ""}>
            {!tab.dropdown ? (
              // <Link
              //   to={tab.path}
              //   className={location.pathname === tab.path ? "active" : ""}
              //   onClick={closeMenu}
              // >
              //   {tab.label}
              // </Link>
              tab.external ? (
                <a
                  href={tab.path}
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="nav-link"
                  onClick={closeMenu}
                >
                  {tab.label}
                </a>
              ) : (
                <Link
                  to={tab.path}
                  className={location.pathname === tab.path ? "active" : ""}
                  onClick={closeMenu}
                >
                  {tab.label}
                </Link>
              )
            ) : (
              <>
                <span
                  onClick={() => handleDropdownToggle(tab.label)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    cursor: "pointer",
                  }}
                >
                  {tab.label}{" "}
                  {openDropdown === tab.label ? (
                    <IoMdArrowDropup />
                  ) : (
                    <IoMdArrowDropdown />
                  )}
                </span>
                {openDropdown === tab.label && renderDropdown(tab.children)}
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SecondaryNavbar;
